export default {
  namespaced: true,
  state: {
    firebaseUser: { email: '' },
  },
  getters: {
    firebaseUser(state) {
      return state.firebaseUser
    },
  },
  mutations: {
    UPDATE_FIREBASE_USER(state, firebaseUser) {
      state.firebaseUser = firebaseUser
    },
  },
  actions: {
    setFirebaseUser({ commit }, authUserResponse) {
      const userToSet = {
        email: authUserResponse.email,
        emailVerified: authUserResponse.emailVerified,
        uid: authUserResponse.uid,
      }
      commit('UPDATE_FIREBASE_USER', userToSet)
    },
  },
}